import React from 'react';
import {Button} from '@mui/material';
import {SVGS} from '../../../../assets/images';
import styles from './logout-button.module.scss';
import {useIntl} from 'react-intl';
import {logout} from '../../../../features/auth/authSplice';
import {store} from '../../../../store/store';
import { Lx } from '../../../../i18n/consts';

const LogoutButton = () => {
    const intl = useIntl();

    const handleLogOut = () => {
        store.dispatch(logout());
    };

    return (
        <Button
            variant='createNew'
            onClick={handleLogOut}
            className={styles.logout}
        >
            <SVGS.LogOutIcon className={styles.svg} />
            <span className={styles.text}>
                {intl.formatMessage({ id: Lx.Login.LOGOUT })}
            </span>
        </Button>
    );
};

export default LogoutButton;
